export default class CoordinateFilter {
  filter(coord) {}
}
export default class CoordinateFilter {
  filter(coord) {}
}
